import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setTokens } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { FullPageSpinner } from "@/components/ui/Spinner";

// The SAML ACS handler redirects here with tokens in the URL fragment
// (never the query string) so they never reach server access logs.
export function SsoCallbackPage() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    const hash = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const accessToken = hash.get("access_token");
    const refreshToken = hash.get("refresh_token");

    if (accessToken && refreshToken) {
      setTokens(accessToken, refreshToken);
      void refreshUser().then(() => navigate("/", { replace: true }));
    } else {
      navigate("/login", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <FullPageSpinner />;
}
